import * as Api from '@Api/index';

import type { SectionData } from '@Types/Order';
import type { Query } from '@Types/Base';

export interface Response {
  ok: boolean;
  data: SectionData[];
}

async function getSections(request: Query) {
  const res = await Api.queryProxi<Response>('/backend/order/get-sections', {}, request);

  return res?.data;
}

export default getSections;
